import { render, staticRenderFns } from "./CandidatesPage.vue?vue&type=template&id=36837469&scoped=true&lang=pug&"
import script from "./CandidatesPage.vue?vue&type=script&lang=js&"
export * from "./CandidatesPage.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesPage.vue?vue&type=style&index=0&id=36837469&lang=scss&scoped=true&"
import style1 from "./CandidatesPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36837469",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
